/**
 * Command Loader — CommandItem boyunda iskelet satırlar
 */

import React from "react";
import { useTranslation } from "react-i18next";

export const CommandLoader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col gap-1.5 p-2"
      role="status"
      aria-label={t("slashCommands.loading")}
    >
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="flex items-center gap-3 rounded-2xl px-3 py-2.5"
        >
          <span className="size-10 shrink-0 animate-pulse rounded-xl bg-module-accent-soft" />
          <span className="flex min-w-0 flex-1 flex-col gap-2">
            <span className="h-3 w-1/3 animate-pulse rounded-md bg-module-accent-soft" />
            <span className="h-2.5 w-1/2 animate-pulse rounded-md bg-module-accent-soft/70" />
          </span>
        </div>
      ))}
    </div>
  );
};
